// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export type DemoDataEnvRecord = Record<string, string | boolean | undefined>;

function isTrue(value: string | boolean | undefined): boolean {
  return value === true || value === "true";
}

/**
 * Demo data is on only when it is asked for explicitly: the runtime
 * `__RIDDLE_ENV__.DEMO_DATA` or the build-time `VITE_DEMO_DATA`. It is never
 * on in a production build, and never because a token is missing (issue 910).
 */
export function resolveDemoDataEnabled(
  runtimeEnv: DemoDataEnvRecord,
  buildEnv: DemoDataEnvRecord,
): boolean {
  if (isTrue(buildEnv.PROD)) {
    return false;
  }
  return isTrue(runtimeEnv.DEMO_DATA) || isTrue(buildEnv.VITE_DEMO_DATA);
}
